import axios from "axios";
import config from "../config";
import { getAuthToken } from "../utils/sessionStorage";

export function create(url, data) {
  return axios({
    method: "post",
    url: `${config.url}${url}`,
    headers: { "X-User-Token": getAuthToken() },
    data: data
  });
}

export function post(url, data) {
  return create(url, data);
}

export function update(url, data) {
  return axios({
    method: "put",
    url: `${config.url}${url}`,
    headers: { "X-User-Token": getAuthToken() },
    data: data
  });
}

export function get(url, data) {
  return axios({
    method: "get",
    url: `${config.url}${url}`,
    headers: { "X-User-Token": getAuthToken() }
  });
}



// WEBPACK FOOTER //
// ./src/utils/apiService.js